import { observer } from 'mobx-react-lite'
import { useRef, type FC } from 'react'
import { useMediaController } from 'widgets/PresentationMode/hooks/useMediaController'
import styles from 'widgets/RecordVideo/ui/styles.module.scss'
import type { RecordStore } from 'widgets/Record'

type IVideoRecordProps = {
  recordStore: RecordStore
}

export const VideoRecord: FC<IVideoRecordProps> = observer(({ recordStore }) => {
  const { mediaControllerStore, src } = recordStore

  const ref = useRef<HTMLVideoElement>(null)

  const { handelEnded, onLoadedData } = useMediaController({
    mediaControllerStore,
    ref,
  })

  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      onLoadedData={onLoadedData}
      onEnded={handelEnded}
      ref={ref}
      src={src}
      className={styles.record}
    />
  )
})
